import client from './client';

export default (function HometownGroupPnmService() {
  let service;

  if (!service) {
    service = client.service('hometownGroupPnms');
  }

  return service;
}());
